import { createAction } from '@reduxjs/toolkit'

export const addEntry = createAction('entries/addEntry')
export const updateEntry = createAction('entries/updateEntry')
export const updateIndex = createAction('entries/updateIndex')
export const deleteEntry = createAction('entries/deleteEntry')
export const deleteEntriesBySheet = createAction('entries/deleteEntriesBySheet')
export const copyEntry = createAction('entries/copyEntry')
export const applyDefaultsOnSave = createAction('entries/applyDefaultsOnSave')
